<div class="wizard-container" style="position: relative;">
  <!-- Back Button -->
  <button (click)="goBackToDashboard()" style="position: absolute; left: 2rem; top: 2rem; background: white; border: 1px solid #eee; font-size: 1.2rem; color: #555; cursor: pointer; display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 50%; box-shadow: 0 2px 8px rgba(0,0,0,0.05); z-index: 10;">
    <i class="bi bi-chevron-left"></i>
  </button>

  <!-- Header -->
  <div class="wizard-header">
    <div class="wizard-title">
      <i [class]="headerIcons[currentStep - 1]" class="step-icon"></i>
      <h1>{{ headerTitles[currentStep - 1] }}</h1>
    </div>

    <div class="wizard-steps">
      <div *ngFor="let step of steps; let i = index" class="step" [class.active]="currentStep === i + 1"
        [class.completed]="i + 1 < currentStep">
        <div class="step-circle">
          <i *ngIf="i + 1 < currentStep" class="bi bi-check-lg"></i>
          <span *ngIf="i + 1 >= currentStep">{{ i + 1 }}</span>
        </div>
        <p class="step-label">{{ step }}</p>
      </div>
    </div>

    <div class="wizard-progress">
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="progressPercent"></div>
      </div>
      <div class="progress-info">
        <span>Step {{ currentStep }} of {{ steps.length }}</span>
        <span class="progress-percent">{{ progressPercent }}% Complete</span>
      </div>
    </div>
  </div>

  <!-- Step Views -->
  <ng-container [ngSwitch]="currentStep">
    <app-step-setup-interview *ngSwitchCase="1" (continue)="handleContinue()"></app-step-setup-interview>

    <app-step-add-context *ngSwitchCase="2" (continue)="handleContinue()" (back)="prevStep()" (skip)="handleSkip()"></app-step-add-context>

    <app-step-choose-options *ngSwitchCase="3" (continue)="handleContinue()"
      (back)="prevStep()"></app-step-choose-options>

    <app-step-device-check *ngSwitchCase="4" (continue)="handleContinue()" (back)="prevStep()"></app-step-device-check>

    <app-step-instructions *ngSwitchCase="5" (continue)="handleContinue()" (back)="prevStep()"></app-step-instructions>

    <app-step-interview *ngSwitchCase="6" (back)="prevStep()"
      [isNavigatingFromWizard]="isNavigating"></app-step-interview>
  </ng-container>

</div>
